// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__345it","col":"styles_col__3L3Ke","actions":"styles_actions__3Isf4","conflict":"styles_conflict__3J16Q"};